<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="button" (click)="onSubmit()" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
        <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <h4>Buscador de Reglas de Correo</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label class="col-form-label" for="inpRegla">Regla</label>
                                    <input formControlName="Regla" name="Regla" maxlength="100" title="" class="form-control" id="inpRegla" type="text" value="">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">
                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <!--DATAGRID-->

        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Reglas de Correo
                    </div>

                    <div class="card-body-grid">

                        <table class="table table-sm ">
                            <!-- table-responsive -->
                            <thead>
                                <tr>
                                    <th class="cabecerasTablaDetalles"></th>
                                    <th class="cabecerasTablaDetalles">Activa</th>
                                    <th style="text-align:left" class="cabecerasTablaDetalles">
                                        &nbsp;Regla
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr formArrayName="resultReglaFormArray" *ngFor="let item of resultReglaCorreoUsuarioList; let i = index">
                                    <td></td>
                                    <td style="text-align:center"><p-checkbox [formControlName]="i" binary="true"></p-checkbox></td>
                                    <td> &nbsp;{{ item.Regla}}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </div>
            </div>
        </div>
    </div>

</form>
